/**
 * Is this OAuth postMessage from the popup THIS window opened? (L10)
 *
 * Every real sender — our popup pages and the backend's popup callback — puts
 * the popup id (= OAuth state) on the message, and the opener stored that id
 * in sessionStorage when it opened the popup. A message without the matching id
 * did not come from our popup, so it must not trigger "connected" handling.
 * Mirrors the check OAuthPopupHandler already does.
 */
export const isExpectedPopupMessage = (data, storage = window.sessionStorage) => {
  const id = data?.popup_id || data?.state;
  if (typeof id !== 'string' || !id) return false;

  let expected = [];
  try {
    expected = [storage.getItem('oauth_popup_id'), storage.getItem('oauth_state')];
  } catch {
    return false; // storage blocked: we can't tell, so don't act
  }
  return expected.some((value) => value && value === id);
};
